export const nombreDeRol = {
  PadronConsultar: "Padrón-Consultar",
  PadronConsultarSolicitudes: "Padrón-Consultar Solicitudes",
  PadronTramitarSolicitudes: "Padrón-Tramitar Solicitudes",
  InformacionCrediticiaConsultaReporte:
    "Información Crediticia-Consultar Reporte",
  InformacionCrediticiaDescargaArchivos:
    "Información Crediticia-Descargar Archivo CPH",
  AutorizacionConsultar: "Autorización-Consultar",
  AutorizacionRevocar: "Autorización-Revocar",
  AutorizacionTramitar: "Autorización-Tramitar",
  AutorizacionEliminar: "Autorización-Eliminar",
  CambiosCicAprobar: "Cambios CIC-Aprobar",
  CambiosCicSolicitar: "Cambios CIC-Solicitar",
};
